// src/encounter/signed-save-refused-notice.tsx
// PROD-2810 / rule 38 — a save the server refused because the note is signed is never silent.
//
// Dev enforces the server freeze (`SignedNoteFreeze:Enforce`): after a PROVIDER sign, an in-place
// write answers 409 `encounter-signed`. That happens when this tab did not know about the sign yet
// (signed in another tab, or a save in flight when the sign landed), or for an encounter-record field
// (vitals, chief complaint, Fall / Pain) that has no amendment path. The page then says so above the
// step canvas, on both paths (frame v2 and the switch-off canvas), with the existing DS Banner, and the
// refused step is not shown as saved or completed. Nothing is retried.
//
// Presentational only: the page picks the sentence (lib/signed-refusal.ts `signedRefusalSentence`).
import { Banner } from '@scripsteam/scrips-signal-ds';

export interface SignedSaveRefusedNoticeProps {
  /** The sentence for what was refused; null/absent → nothing renders. */
  sentence?: string | null;
}

export function SignedSaveRefusedNotice({ sentence }: SignedSaveRefusedNoticeProps) {
  if (!sentence) return null;
  return (
    <Banner variant="error" data-testid="signed-save-refused">
      {sentence}
    </Banner>
  );
}
